import { useEffect } from 'react';
import { useTitle } from '../context/TitleContext';
import { Row } from 'react-bootstrap';
import Stats from './dashboard/components/Stats';
import Conversions from './dashboard/components/Conversions';
import Orders from './dashboard/components/Orders';
import '../styles/dashboard.scss';

const Dashboard = () => {
  const { setTitle } = useTitle();

  useEffect(() => {
    setTitle('Dashboard');
  }, [setTitle]);

  return (
    <div className="dashboard-page">
      <Row className="g-3">
        <Stats />
        <Conversions />
        <Orders />
      </Row>
    </div>
  );
};

export default Dashboard;
